// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LogoutFlow-module__SpinnerContainer__bKUZ_ {
    position: fixed;
    z-index: 1;
    background: var(--ds-overlay-bg-color);
    backdrop-filter: blur(var(--ds-blur-4));
    inset: 0;
}

.LogoutFlow-module__Spinner__s9TrV {
    background: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SpinnerContainer": `LogoutFlow-module__SpinnerContainer__bKUZ_`,
	"Spinner": `LogoutFlow-module__Spinner__s9TrV`
};
export default ___CSS_LOADER_EXPORT___;
